import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Field, reduxForm } from 'redux-form';
import { Row, Col } from 'react-bootstrap';
import styled from 'styled-components';
import ButtonLiquidPrimary from 'components/atoms/buttons/liquid/Primary';
import TextInput from 'components/atoms/inputs/TextInput';
import { parseLocationUrl } from 'services/router/selectors';
import { submitSetPasswordForm } from 'services/auth/duck';
import FormButtonWrapper from 'components/atoms/form/FormButtonWrapper';
import { isPasswordResetToken } from 'helpers/isPasswordResetToken';

const InstructionText = styled.p`
    font-size: 16px;
    margin-bottom: 0px;
`;

const InstructionWrapper = styled.div`
    margin-bottom: 33px;
`;

const AlignedCol = styled(Col)`
    text-align: ${props => props.direction || 'left'}
`;

class SetPasswordForm extends Component {
    render() {
        const { search } = parseLocationUrl({ router: { location: this.props.location } });

        let message = ['Welcome!', 'Set your password to get started.'];
        if (search.token && isPasswordResetToken(search.token)) {
            message = ['Welcome back!', 'Please enter your new password to reset it.'];
        }

        return (
            <Form onSubmit={this.props.handleSubmit(submitSetPasswordForm)} id="setPasswordForm">
                <InstructionWrapper>
                    {message.map((msg, idx) => (
                        <InstructionText key={idx}>{msg}</InstructionText>
                    ))}
                </InstructionWrapper>
                <Field component={TextInput} name="password" label="PASSWORD" type="password" />
                <Field component={TextInput} name="confirmPassword" label="CONFIRM PASSWORD" type="password"/>

                <Row>
                    <AlignedCol md={8}>
                        <FormButtonWrapper>
                            <ButtonLiquidPrimary type="submit">SET PASSWORD</ButtonLiquidPrimary>
                        </FormButtonWrapper>
                    </AlignedCol>
                </Row>
            </Form>
        );
    }
}

const mapStateToProps = state => ({
    location: state.router.location
});

export default connect(mapStateToProps)(reduxForm({
    form: 'set-password'
})(SetPasswordForm));



// WEBPACK FOOTER //
// ./src/components/organisms/forms/CreatePassword.js